import React from "react";
import { Alert } from "antd";
import DynamicTable from "../../../components/DynamicTable";
import { rupees } from "../formatters";

function LedgerTable({ data }) {
  return (
    <>
      <Alert
        type="info"
        message={`Totals scope: ${data.ledger_scope}. Campaign filter applies to awards and referrals only. Issued points and redeemed credit are the same value at different stages; do not add them together.`}
      />
      <DynamicTable
        showAction={false}
        rowKey="kind"
        dataSource={data.ledger_totals}
        columns={[
          {
            title: "Event",
            dataIndex: "kind",
          },
          {
            title: "Point movement",
            dataIndex: "points",
          },
          {
            title: "Credit movement",
            dataIndex: "amount_paise",
            render: rupees,
          },
        ]}
      />
    </>
  );
}
export default LedgerTable;
